/* eslint-disable camelcase */ 

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_from_prenatal_yoga_to_yoga_nidra_our_platform_caters_to_diverse_interests_and_levels_ensuring: Phrase =locale => {
  const en = `From prenatal yoga to yoga nidra, our platform caters to diverse interests and levels, ensuring something for everyone.`;
  const phrases: { [key: string]: undefined | string } = {
    en, 
    es: `Desde yoga prenatal hasta yoga nidra, nuestra plataforma se adapta a diversos intereses y niveles, garantizando clases para todos los gustos.`,
  };
  return phrases[locale] || en;
};
            